import { h, Component } from 'preact';
import { Link } from 'preact-router';
import style from './style.less';

export default class Footer extends Component {
	render(props) {
		return; //TODO return to footer mode once feed is implemented

		return <footer class={style.footer}>
			{ this.footerContent() }
		</footer>
	}

	footerContent() {
		if (this.props.currentUser) {
			let nav = {
				updates: ["/feed","feed"],
				contacts: ["/","friends"],
				"my profile": ["/me","profile"]
			};
			return <nav class={"nav nav-fill " + style.footer_nav}>
				{Object.keys(nav).map(name=>(
					<a class={this.getSpriteClassString(nav[name])} href={nav[name][0]}>
						{name}
						<span class={style.active_indicator}></span>
					</a>
				))}
			</nav>
		}
		return <div class="text-center py-3"><span class={style.copyright}>Copyright &copy; 2019</span></div>
	}

	getSpriteClassString(navSpec) {
		let current = window.location.pathname === navSpec[0];
		let active = current ? style.active + " " : "";
		return "nav-item nav-link " + active + style["sprite_" + navSpec[1]];
	}
}



// WEBPACK FOOTER //
// ./components/footer/index.js